/* global axios */
import ApiClient from 'dashboard/api/ApiClient';

class FlowFoldersAPI extends ApiClient {
  constructor() {
    super('flow_folders', { accountScoped: true });
  }

  index() {
    return axios.get(this.url);
  }

  create(payload) {
    return axios.post(this.url, payload);
  }

  update(folderId, payload) {
    return axios.patch(`${this.url}/${folderId}`, payload);
  }

  destroy(folderId) {
    return axios.delete(`${this.url}/${folderId}`);
  }
}

export default new FlowFoldersAPI();
